<svelte:options tag={null} />

<script lang="ts">
  import type { StepperItems } from './stepper.types';
  import { EventHandler } from '../../utilities/EventHandler';

  export let steps: string;
  export let compact = false;
  let eventHandler = new EventHandler();
  $: stepsObject = steps
    ? (JSON.parse(steps) as StepperItems[])
    : ([] as StepperItems[]);
  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  function isStepValidated(
    index: number,
    stepsObject: StepperItems[],
  ): boolean {
    return (
      index < stepsObject.findIndex((step: StepperItems) => step.isCurrent)
    );
  }

  function getStepNumber(index: number, stepsObject: StepperItems[]): string {
    return `${index + 1} / ${stepsObject.length}`;
  }

  function stepChanged(step: StepperItems): void {
    eventHandler.dispatch('step-changed', step);
  }
</script>

<nav
  class="mc-stepper {compact ? 'mc-stepper--compact' : ''} {stepsObject.length >
  3
    ? 'mc-stepper--shrinked'
    : ''}"
  aria-label="accessibilityLabels.stepperDescription"
  {...attributes}
>
  <ol class="mc-stepper__list">
    {#each stepsObject as step, index}
      <li
        class="mc-stepper__item {step.isCurrent
          ? 'mc-stepper__item--current'
          : ''} {isStepValidated(index, stepsObject)
          ? 'mc-stepper__item--validated'
          : ''}"
        on:click={() => stepChanged(step)}
      >
        <div class="mc-stepper__indicator" aria-hidden="true">
          {#if isStepValidated(index, stepsObject)}
            <div class="mc-stepper__icon">
              <navigation-notification-available-16px
                name="NotificationAvailable16"
                size="100%"
              />
            </div>
          {:else if step.isCurrent}
            <span>{index + 1}</span>
          {/if}
        </div>
        <div class="mc-stepper__detail">
          <span class="mc-stepper__title"
            >{getStepNumber(index, stepsObject)}
          </span>
          <span class="mc-stepper__label">{step.label}</span>
        </div>
      </li>
    {/each}
  </ol>
</nav>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/_c.stepper';
</style>
